// FAQ block schema - Accordion Q&A section
export const faqSchema = {
  type: 'faq',
  label: 'FAQ',
  description: 'Accordion-style frequently asked questions section',
  icon: 'HelpCircle',
  defaultContent: {
    heading: 'Frequently Asked Questions',
    style: {},
    items: [
      {
        id: 'faq_1',
        question: 'What is your first question?',
        answer: 'Add your answer here. You can provide detailed information that helps your visitors.',
      },
    ],
  },
  fields: [
    { name: 'heading', label: 'Section Heading', type: 'text', placeholder: 'Frequently Asked Questions' },
    { name: 'items', label: 'FAQ Items', type: 'array' },
  ],
};
